"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventEmitter = exports.OPEN_SUBSCRIPTION_POPUP = void 0;
var _events = require("events");
const eventEmitter = exports.eventEmitter = new _events.EventEmitter();
const OPEN_SUBSCRIPTION_POPUP = exports.OPEN_SUBSCRIPTION_POPUP = 'OPEN_SUBSCRIPTION_POPUP';